import { useConnectionsTableActions } from '@mm/state/modules/connectionsTableState/actions';
import React, { useEffect } from 'react';
import ConnectionsTableGrid from '../../../../connections/components/ConnectionsTableGrid/ConnectionsTableGrid';
import ZapierPanel from '../../../../zapier/panels/ZapierPanel/ZapierPanel';
import { GoogleSheetsIntegration } from './components/GoogleSheetsIntegrations/GoogleSheetsIntegration';
import { KlaviyoIntegrations } from './components/KlaviyoIntegrations/KlaviyoIntegrations';
import { MailchimpIntegration } from './components/MailchimpIntegrations/MailchimpIntegration';
import { SalesForceIntegrations } from './components/SalesForceIntegrations/SalesForceIntegrations';
import { SendlaneIntegrations } from './components/SendlaneIntegrations/SendlaneIntegrations';
import './NativeIntegrations.scss';

export const NativeIntegrations = () => {
  const { resetState } = useConnectionsTableActions();

  useEffect(() => {
    resetState();
  }, [resetState]);

  return (
    <div className="native-integrations">
      <KlaviyoIntegrations />
      <GoogleSheetsIntegration />
      <ZapierPanel />
      <ConnectionsTableGrid />
      <MailchimpIntegration />
      <SalesForceIntegrations />
      <SendlaneIntegrations />
    </div>
  );
};
